import { NeutralColors } from '@cseo/styles/lib/coherence/CoherenceColors';

export const Main = styled.main`
    background: ${NeutralColors.gray10};
    flex: 1 0 auto;
    margin-top: 44px;
    overflow-x: hidden;
`;

export const Footer = styled.footer`
    text-align: right;
    background: white;
`;
